import React, { useEffect, useState, useRef,useContext, useReducer } from 'react';
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { Modal } from '../../components/modal/Modal';
import { SearchTable } from '../../components/utils/SearchTable';
import { useCentroAyuda } from '../../../hooks/useCentroAyuda';
import { ModalRecarga } from '../../components/modal/ModalRecarga';
import { Tooltip } from '../../components/utils/Tooltip';
import { notify, primeraLetraMayuscula, seleccionarArchivo, eventDrag, eventPaste, eventDrop, eliminarTodasLasExtensiones, obtenerExtension } from '../../../utils/utils';
import { useChat } from '../../../context/provider/ChatProvider';
import useChatActions from '../../../hooks/chat/useChatActions';
import { UserContext } from '../../../context/provider/UserProvider';
import { SocketContext } from '../../../context/provider/SocketProvider';
import sonidoRecarga from '../../../assets/sound/sonidoRecarga.mp3'
import { useModal } from '../../../hooks/useModal';
import { DatePickerDoble } from '../../components/pickers/DatePickerDoble';

const archivoReducer = (estado, accion) => {
    switch(accion.tipo){
        case 'Agregar':
            return [...estado, ...accion.carga];
        case 'Remover':
            return estado.filter(file => file?.codigo ? 
                (file.codigo !== accion.carga.codigo) : (file.identificador !== accion.carga.identificador)
            );
        case 'Reiniciar':
            return []
        case 'Cargar':
            return accion.carga
        default:
            return estado;
    }
}

export const CentroAyuda = () => {
    const { stateUser } = useContext(UserContext);
    const { sendMessage } = useChatActions();
    const { joinRoom, leaveRoom } = useChatActions();
    const { currentRoom, setCurrentRoom, userName, socket } = useChat();
    const { stateSocket } = useContext(SocketContext);
    const ultimoElementoRef = useRef(null);
    const audioRecarga = useRef(null);
    const idTablaCentroAyuda = 'tbCentroAyuda';
    const classNameInput = "text-white h-[30px] rounded px-4 bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500";
    const [ startDate, setStartDate ] = useState(new Date());
    const [ endDate, setEndDate ] = useState(new Date());
    const [ codEstadoReclamo, setCodEstadoReclamo ] = useState(0);
    const [ ordenAscendente, setOrdenAscendente ] = useState(true);
    const [ isOpenModalReclamo, openModalReclamo, closeModalReclamo ] = useModal(false);
    const [ isOpenModalSolucion, openModalSolucion, closeModalSolucion ] = useModal(false);
    const isOpenModalReclamoRef = useRef(false);
    const [ archivo, setArchivo ] = useReducer(archivoReducer, [])
    const [ esArrastrar, setEsArrastrar ] = useState(false);
    const textAtencionRef = useRef(null);
    const documentosValidos = [
        'application/pdf',                                                        // pdf
        'text/plain',                                                             // txt
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // xlsx
        'application/vnd.ms-excel',                                               // xls
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',// pptx
        'application/vnd.ms-powerpoint',                                          // ppt
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',// docx
        'application/msword'                                                      // doc
    ]
    const {
        reclamos,
        listarReclamos,
        detalleReclamo,
        obtenerDetalleReclamo,
        mensajesPorSala,
        obtenerMensajesPorSala,
        mensajeWeb,
        editarValorMensajeWeb,
        editarValorRegistroSolucion,
        registroSolucion,
        guardarSolucionReclamo,
        iniciarAtencionReclamo
    } = useCentroAyuda();

    useEffect(() => {
        socket && socket.on('message-received', (data) => {
            if(isOpenModalReclamoRef.current){
                obtenerMensajesPorSala(data.room)
            }
        })

        socket && socket.on('pending-messages', async (data) => {            
            data.uid === stateUser.codUsuario &&  notify(`Recibió ${data.pendingMessagesQuantity}
                ${Number(data.pendingMessagesQuantity) === 1 ? ' nuevo mensaje ' : ' nuevos mensajes'} en el reclamo: ${data.ticket}`,
                'info', { autoClose: true }
            )
            listarReclamos(startDate, endDate);
        });

        return () => {
            socket && socket.off('message-received');
            socket && socket.off('pending-messages');
        }
        
    }, [socket]);

    useEffect(() => { //Notificacion MQTT
        if (Object.keys(stateSocket.payload).length > 0) {
            // audioRecarga?.current?.play(); 
            
            if (stateSocket.payload.message.hd.cmd == "setNotificacionReclamoWeb"){ //notificacion de chat
                if (audioRecarga.current) {
                    audioRecarga.current.play()
                    .catch(error => {
                        console.error('La reproducción del sonido falló:', error);
                        });
                }
                notify(stateSocket.payload.message.bd.mensaje, 'success', { autoClose: true });
                listarReclamos(startDate, endDate);//lista de centro de ayuda
            }else{// notificacion de nueva recarga
                // listarReclamos(startDate, endDate)
                // notify('¡Se recibió una petición de Recarga!', 'info', { autoClose: true });
            }
        }
    }, [stateSocket.payload])

    useEffect(() => {
        console.log('mensajesPorSala ',mensajesPorSala)
        setTimeout(() => {
            ultimoElementoRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 0);
    },[mensajesPorSala, ultimoElementoRef])

    useEffect(() => {
        listarReclamos(startDate, endDate);
    },[startDate, endDate])

    useEffect(() => {
        isOpenModalReclamoRef.current = isOpenModalReclamo
    },[isOpenModalReclamo])

    const generarEstado = (codEstado,nomEstado) => {
        let claseEstado = ''
        switch(codEstado){
            case 9: claseEstado = 'bg-yellow-500';
                break;
            case 45: claseEstado = 'bg-green-500';
                break;
            case 18: claseEstado = 'bg-blue-500';
                break;
            default: claseEstado = 'bg-cyan-500'
                break;
        }
        return <label className={`${claseEstado} rounded px-2 inline-block w-[80px] text-center`}>{nomEstado}</label>
    }

    const obtenerDatosReclamo = async (data) => {
        await obtenerDetalleReclamo(data.codUsuarioReclamo);
        await handleRoomClick(data.idRoom)
        editarValorMensajeWeb('comentario','');
        editarValorMensajeWeb('codUsuarioReclamo',data.codUsuarioReclamo)
        editarValorMensajeWeb('uidCreacion',data.uIDCreacion)
        editarValorMensajeWeb('idRoom',data.idRoom)
        if(data.idRoom === ''){
            notify('El Id de la sala es vacío', 'error')
            return
        }
        await obtenerMensajesPorSala(data.idRoom);
        openModalReclamo();
        await listarReclamos(startDate, endDate);
    }
    // Handle room selection
    const handleRoomClick = async (roomID) => {
        if (currentRoom?.id === roomID) {
            return;
        }
        setRoom(roomID)
    };

    const setRoom = (roomID) => {
        setCurrentRoom(roomID);
        joinRoom({ roomID, userName });
    }

    const enviarMensajeAtencion = async (e, urlMinio) => {
        e.preventDefault();
        const mediaFile = {
            mime: archivo.length > 0  ? archivo[0].type : 'text/plain',
            original: archivo.length > 0  ? archivo[0].nombre : '',
            type: archivo.length > 0 ? archivo[0].type : 'text/plain',
            size: archivo.length > 0 ? archivo[0].size : 0,
            url: archivo.length > 0 ? (archivo[0].type.indexOf('image') === 0 ? urlMinio.urlVer: urlMinio.urlDescargar) : '',
            key: ''
        }
        let tipoMensaje = archivo.length > 0 ? (archivo[0].type.startsWith('image/') ? 'image' : 
            (archivo[0].type.startsWith('video/') ? 'video' : 'file')) : ''
            if(archivo.length === 0 && mensajeWeb.comentario.length === 0){
                textAtencionRef.current?.focus();
                notify('Debe ingresar un mensaje o seleccionar un archivo', 'error');
                return
            }
        sendMessage(
            currentRoom, 
            mensajeWeb.comentario.length > 0 ? mensajeWeb.comentario : (archivo.length > 0 ? " " : ""), 
            stateUser.uid,
            archivo.length > 0 ? tipoMensaje : 'text',
            archivo.length > 0 ? mediaFile : ''
        );
    };

    const enviarRespuestaReclamo = async (event) => {
        const urlMinio = await subirArchivo();
        await enviarMensajeAtencion(event, urlMinio);
        await obtenerMensajesPorSala(currentRoom);
        editarValorMensajeWeb('comentario','');
        setArchivo({tipo: 'Remover', carga: archivo[0]})
    }

    const guardarSolucion = async () => {
        const isValid = await guardarSolucionReclamo();
        if(isValid){
            listarReclamos(startDate, endDate)
            await obtenerDetalleReclamo(registroSolucion.codUsuarioReclamo)
            closeModalSolucion()
            editarValorRegistroSolucion('codUsuarioReclamo', );
            editarValorRegistroSolucion('comentario', '');
            editarValorRegistroSolucion('solucionado', true);
        }
    }

    const formatoFecha = (dateString) => {
        // Crear un objeto Date a partir del string de fecha
        const date = new Date(dateString);
    
        // Extraer los componentes de la fecha
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
    
        // Formatear la fecha en el formato deseado
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    const iniciarAtencion = async (idRoom,codUsuarioReclamo) => {
        const isValid = await iniciarAtencionReclamo(codUsuarioReclamo);
        if(isValid){
            await obtenerDetalleReclamo(codUsuarioReclamo);
            await obtenerMensajesPorSala(idRoom)
        }
    }

    const subirArchivo = async () => {
        if (!archivo || archivo.length === 0){
            return {urlVer: "" , urlDescargar: ""}
        } 
        const file = archivo[0];
        let nomCarpeta = "chat-biix-files";
        let nomArchivo = eliminarTodasLasExtensiones(file.nombre);
        const formData = new FormData();
        const blob = file.slice(0, file.size , 'aplication/json');
        const nuevoArchivo = new File([blob],file.nombre,{ type: 'aplication/json' });
        formData.append('archivo',nuevoArchivo);
        const queryParameters = {
            NombreCarpeta: nomCarpeta,
            NombreSubCarpeta : "",
            nombreArchivo: nomArchivo
        }
        const urlEnvioMinio = 'https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?' + new URLSearchParams(queryParameters);
        const urlVerImagen = `https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=${nomCarpeta}&NombreImagen=${nomArchivo}`;
        const urlDescargar = `https://miniowebapi.abexacloud.com/api/Archivo/descargarArchivo?NombreCarpeta=${nomCarpeta}&NombreArchivo=${nomArchivo}&Extension=${obtenerExtension(file.nombre)}`;
        
        const response = await fetch(urlEnvioMinio,{
            method:'POST',
            body: formData
        }).then(res => res.json())

        !response.isValid && notify(response.content , 'error')
        return response.isValid ? {urlVer: urlVerImagen, urlDescargar: urlDescargar} : {urlVer: "" , urlDescargar: ""}
    }

    return(
        <>
            <audio ref={audioRecarga} src={ sonidoRecarga} />
            <ContenedorParametros titulo="Centro de ayuda">
                <DatePickerDoble
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <SearchTable tablaId={idTablaCentroAyuda} />
                <i className='fa fa-filter'></i>
                <select
                    className={`${classNameInput}`}
                    onChange={(e) =>setCodEstadoReclamo(Number(e.target.value))}
                >
                    <option value={0}>-- Todos --</option>
                    <option value={9}>Pendiente</option>
                    <option value={45}>En proceso</option>
                    <option value={18}>Atendido</option>
                </select>
            </ContenedorParametros>
            <div className='containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                <table className="table" id={idTablaCentroAyuda}>
                    <thead>
                        <tr key={'abc'+0}>
                            <th className="w-[30px]">N</th>
                            <th className='text-left'>{'Código'.toUpperCase()}</th>
                            <th className='text-left'>{'Tipo reclamo'.toUpperCase()}</th>
                            <th className='text-left'>{'Descripción'.toUpperCase()}</th>
                            <th className='text-left'>
                                {'F. registro'.toUpperCase()}
                                <i 
                                    className={`fa fa-sort-amount-${ordenAscendente  ? 'desc':'asc'} pl-3`}
                                    data-tip={'ordenar'}
                                    data-for={'ordenar'}
                                    onClick={() => setOrdenAscendente(!ordenAscendente)}   
                                ></i>
                                <Tooltip id={'ordenar'}>{ordenAscendente ? 'Orden descendente': 'Orden ascendente'}</Tooltip>
                            </th>
                            <th className='text-left'>{'U. registro'.toUpperCase()}</th>
                            <th className='text-left'>{'F. atención'.toUpperCase()}</th>
                            <th className='text-left'>{'U. atención'.toUpperCase()}</th>
                            <th className='text-left'>{'Estado'.toUpperCase()}</th>
                            <th className=''></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reclamos.length > 0 ?
                                reclamos.sort((a, b) => { // Ordenar por la fecha mas reciente
                                    const parseDate = (dateString) => {
                                        const [date, time] = dateString.split(' ');
                                        const [day, month, year] = date.split('/').map(Number);
                                        const [hours, minutes, seconds] = time.split(':').map(Number);
                                        return new Date(year, month - 1, day, hours, minutes, seconds);
                                    };
                                
                                    const dateA = parseDate(a.fechaHoraCreacion);
                                    const dateB = parseDate(b.fechaHoraCreacion);
                                
                                    return ordenAscendente ? dateB - dateA : dateA - dateB;
                                }).filter(item => {return codEstadoReclamo !== 0 ? item.codEstadoReclamo === codEstadoReclamo : true})
                                .map((r,i) => (
                                    <tr key={`${r.codUsuarioReclamo + '' +i}`}>
                                        <td>{i + 1}</td>
                                        <td>
                                            <label
                                                className='bg-blue-600 px-2 rounded flex w-[50px] justify-center font-semibold'
                                            >{r.codUsuarioReclamo||''}</label>
                                        </td>
                                        <td>{r.nomUsuarioReclamoTipo||''}</td>
                                        <td>{r.descripcionReclamo||''}</td>
                                        <td className=''>{r.fechaHoraCreacion}</td>
                                        <td className=''>{r.uIDCreacion}</td>
                                        <td className=''>{r.fechaHoraAtencion}</td>
                                        <td className=''>{r.uIDAtencion}</td>
                                        <td className='text-left'>{generarEstado(r.codEstadoReclamo,primeraLetraMayuscula(r.nomEstado))}</td>
                                        <td className=''>
                                            {
                                                r.codEstadoReclamo !== 51 ?
                                                <>
                                                <div className='w-[40px] h-[22px]'>
                                                    <button
                                                        className={`${r.codEstadoReclamo !== 18 ? ' bg-green-500 hover:bg-green-600 ' : 
                                                        'bg-blue-500 hover:bg-blue-600'} 
                                                        h-[20px] w-[25px] rounded absolute`}
                                                        data-tip={'atender'+i}
                                                        data-for={'atender'+i}
                                                        onClick={async ()=> await obtenerDatosReclamo(r)
                                                            // editarValorMensajeWeb('codUsuarioReclamo',r.codUsuarioReclamo)
                                                            // editarValorMensajeWeb('uidCreacion',r.uIDCreacion)
                                                            // editarValorMensajeWeb('idRoom',r.idRoom)
                                                            // handleRoomClick(r.idRoom)
                                                        }
                                                    >
                                                        <div className=''>
                                                            <i className="fas fa-comments"></i>
                                                            {
                                                                (r.pendingMessages > 0 && r.codEstadoReclamo !== 18) &&
                                                                <div className='absolute bottom-0 left-4 h-[30px]'>
                                                                    <div className='rounded-full border-2 bg-blue-600 text-base  w-[17px] h-[17px]'>
                                                                        <p className='text-[9px] font-bold left-1.5 top-[-3px]  absolute'>{r.pendingMessages}</p>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                        
                                                    </button>
                                                    <Tooltip id={'atender'+i}>{r.codEstadoReclamo  !== 18 ? 'Atender reclamo' : 'Reclamo atendido'}</Tooltip>
                                                </div>
                                                </>
                                                    
                                                : 
                                                    ''
                                            }
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr>
                                    <td className='text-center' colSpan={10}>No hay información para mostrar...</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>

            {/** MODAL PARA RESPONSER RECLAMO */}
            <ModalRecarga
                isOpen={isOpenModalReclamo}
                closeModal={closeModalReclamo}
                actionRecargar={()=> {
                    editarValorRegistroSolucion('codUsuarioReclamo',mensajeWeb.codUsuarioReclamo);
                    openModalSolucion();
                }}
                actionCancelar={()=> {
                    leaveRoom(currentRoom);
                    closeModalReclamo();
                }}
                title={`Atención [ Código - ${mensajeWeb.codUsuarioReclamo} ]`}
                textButtons={{ confirm: 'Finalizar', denied: 'Denegar', cancel: 'Cerrar' }}
                validButton={{ confirm: detalleReclamo[0]?.codEstadoReclamo === 45 ? true: false, denied: false, cancel:true}}
            >

            <div className='w-[600px]'>
                <div className='px-5 pt-5'>
                    <fieldset className='border border-zinc-500 rounded p-2 text-left'>
                        <legend className='px-2 font-medium'>Detalle reclamo</legend>
                        <div className='flex flex-col gap-1'>
                            <div className='flex'>
                                <span className='w-[30%]'>Comentario</span>
                                <span className='pr-2'>:</span>
                                <input
                                    value={detalleReclamo[0]?.comentario||''}
                                    disabled
                                    readOnly
                                    className={`${classNameInput} disabled:cursor-not-allowed disabled:opacity-70`}
                                />
                            </div>
                            <div className='flex'>
                                <span className='w-[30%]'>Fecha registro</span>
                                <span className='pr-2'>:</span>
                                <input
                                    value={detalleReclamo[0]?.fechaHoraCreacion||''}
                                    disabled
                                    readOnly
                                    className={`${classNameInput} disabled:cursor-not-allowed disabled:opacity-70`}
                                />
                            </div>
                            <div className='hidden'>
                                <span className='w-[30%]'>Fecha reclamo</span>
                                <span className='pr-2'>:</span>
                                <input
                                    value={detalleReclamo[0]?.fechaHoraReclamo||''}
                                    disabled
                                    readOnly
                                    className={`${classNameInput} disabled:cursor-not-allowed  disabled:opacity-70`}
                                />
                            </div>
                        </div>
                    </fieldset>
                </div>
                {
                    detalleReclamo[0].codEstadoReclamo === 9 ? 
                    <div className='h-[150px] w-full flex justify-center items-center'>
                        <button
                            className='bg-green-600 p-2 rounded'
                            onClick={() => iniciarAtencion(mensajeWeb.idRoom, mensajeWeb.codUsuarioReclamo)}
                        >Iniciar atención</button>
                    </div>
                    :
                    <>
                        <div key={'parent-content-chat'} className='px-5 py-2 '>
                            <div key={'content-chat'} className='containerScroll container-message'>
                                {
                                    mensajesPorSala.length > 0 ?
                                        mensajesPorSala.map((r,i) => {
                                            return(
                                            <div
                                                ref={i === mensajesPorSala.length - 1 ? ultimoElementoRef : null}
                                                key={r._id}
                                                className={`w-full flex flex-col ${r.owner.nickname === mensajeWeb.uidCreacion ? ' items-start ' : ' items-end '}`}
                                            >
                                                <div
                                                    key={'global-message-' + (i+1)}
                                                    className={`${r.owner.nickname === mensajeWeb.uidCreacion ? 'message-cliente' : 'message-atencion'}`}
                                                >
                                                    <p
                                                        className={`message-content
                                                            ${r.owner.nickname === mensajeWeb.uidCreacion ?
                                                            'text-red-600' : 'text-green-700'} font-bold`
                                                        }
                                                    >{r.owner.nickname}</p>
                                                    <p className="message-content" style={{wordBreak: 'breakWord','white-space': 'pre-wrap', 'text-align': 'justify', 'text-justify': 'inter-word', 'hyphens': 'auto'}}>{r.content}</p>
                                                    {
                                                        r.messageType === "text" ? ''
                                                        :
                                                            (
                                                                r.messageType === "image" ? 
                                                                    <img
                                                                        title={r.media.original}
                                                                        data-for
                                                                        data-tip={'id_' + r._id}
                                                                        src={r.media.url}
                                                                        onClick={()=> window.open(r.media.url,'_blank')}
                                                                        alt="Imagen"
                                                                        className="cursor-pointer max-w-full max-h-full w-[70px] h-[70px]"
                                                                    />
                                                                :
                                                                    
                                                                    <span
                                                                        title={r.media.original}
                                                                        data-for
                                                                        data-tip={'id_' + r._id}
                                                                        className='text-3xl cursor-pointer'
                                                                        onClick={()=> window.open(r.media.url,'_blank')}
                                                                    >{r.messageType === "video" ? '🎞️' : '📄'}</span>
                                                            )
                                                            // +
                                                            // <>
                                                            //     <Tooltip id={'id_' + r._id}>{r.media.original || ''}</Tooltip>
                                                            // </>
                                                    }
                                                    <time
                                                        className={`${r.owner.nickname === mensajeWeb.uidCreacion ? 
                                                            'message-fechaHoraCliente' : 'message-fechaHoraAtencion'} font-semibold`
                                                        }
                                                    >{formatoFecha(r.createdAt)}</time>

                                                </div>
                                            </div>
                                        )})
                                    : ''
                                }
                            </div>
                        </div>
                        <div
                            key={'content-option'}
                            className='px-5 py-2'
                            onPaste={(e) => eventPaste(e, setArchivo, archivo.length > 0)}
                            onDragOver={(e) => eventDrag(e, setEsArrastrar, archivo.length > 0)}
                            onDrop={(e) => eventDrop(e, setArchivo, setEsArrastrar, archivo.length > 0)}
                        >
                            {
                                detalleReclamo[0].codEstadoReclamo === 45 && (
                                    <>
                                        <div
                                            key={'content-params'}
                                            className={` flex gap-2 pt-2 items-center
                                            ${esArrastrar ? 'hidden' : 'visible'}`}
                                        >
                                            <input
                                                type="file"
                                                className="hidden"
                                                id="fileInput"
                                                onChange={(e)=>{seleccionarArchivo(e, setArchivo)}}
                                            />
                                            <label
                                                htmlFor="fileInput"
                                                className={`cursor-pointer ${esArrastrar ? 'hidden' : (archivo.length > 0 ? 'hidden' :'visible')}`}
                                            >
                                                <i
                                                    data-for
                                                    data-tip={"icon-adjuntar"}
                                                    className="fa-solid fa-paperclip text-zinc-400 text-xl"
                                                ></i>
                                                <Tooltip id={"icon-adjuntar"}>{"Adjuntar archivo"}</Tooltip>
                                            </label>
                                            <fieldset
                                                className={`${archivo.length > 0 ? "w-[64px] h-[64px] " : "hidden"}
                                                flex items-center justify-center border border-zinc-500 rounded px-1 `}
                                            >
                                                <legend className="text-xs text-zinc-400">Adjunto</legend>
                                                {
                                                    archivo.length > 0 && (
                                                        <div
                                                            key={'content-file-adj'}
                                                            className="w-[40px] h-[40px] relative"
                                                        >
                                                            {
                                                                archivo[0].type.indexOf('image') === 0 ?
                                                                    <img
                                                                        src={URL.createObjectURL(archivo[0])}
                                                                        alt="Imagen adjunta"
                                                                        className="max-h-full max-w-full object-fill cursor-pointer"
                                                                        onClick={() => window.open(URL.createObjectURL(archivo[0]),'_blank')}
                                                                    />
                                                                :
                                                                    <span className="text-3xl">
                                                                        {archivo[0].type.startsWith('video/') ? '🎞️' : '📄'}
                                                                    </span>
                                                            }
                                                            <i
                                                                className="fa-solid fa-square-xmark absolute cursor-pointer
                                                                -top-1 -right-2 text-red-500 hover:text-red-700"
                                                                onClick={()=>setArchivo({tipo: 'Remover', carga: archivo[0]})}
                                                                data-for data-tip={"icon-remove"}
                                                            ></i>
                                                            <Tooltip id={"icon-remove"}>{"Eliminar archivo"}</Tooltip>
                                                        </div> 
                                                    )
                                                }

                                            </fieldset>
                                            <textarea
                                                ref={textAtencionRef}
                                                className={`${classNameInput} w-full h-[64px] 
                                                p-1 resize-none containerScroll caret-white `}
                                                placeholder='Escribir aqui...'
                                                onChange={(e) => {editarValorMensajeWeb('comentario',e.target.value)}}
                                                value={mensajeWeb.comentario}
                                                onPaste={(e) => e.stopPropagation()}
                                            />
                                            <button
                                                className={`bg-blue-600 rounded
                                                px-2 h-[40px] hover:bg-blue-800flex gap-1 items-center`}
                                                onClick={(e) => enviarRespuestaReclamo(e)}
                                            >
                                                <i className='fa fa-paper-plane'></i>
                                            </button>
                                        </div>
                                        <div className={`${esArrastrar ? 'visible' : 'hidden'} w-full h-[64px]
                                            border border-dashed border-zinc-400 opacity-60 flex items-center justify-center`}
                                        >
                                            Deje el archivo aquí...
                                        </div>
                                    </>
                                    
                                )
                            }
                        </div>
                    </>
                }
            </div>

            </ModalRecarga>

            {/* MODAL PARA SOLUCIONAR RECLAMO */}
            <Modal
                isOpen={isOpenModalSolucion}
                closeModal={closeModalSolucion}
                title={'Finalizar atención'}
                validButton={{
                    confirm: true,
                    denied: true,
                }}
                textButtons={{
                    confirm: 'Guardar',
                    denied: 'Cancelar'
                }}
                action={() => guardarSolucion()}
            >
                <div className='w-[300px]'>
                    <div className='w-full flex flex-col'>
                        <label>Comentario</label>
                        <textarea
                            className={`${classNameInput} h-[80px]`}
                            onChange={(e) => {editarValorRegistroSolucion('comentario',e.target.value)}}
                        />
                    </div>
                    <div className='flex gap-2 items-center pt-2'>
                        <label>Solucionado</label>
                        <label className="switch">
                            <input 
                                className='' 
                                type="checkbox" 
                                checked={registroSolucion.solucionado || false} 
                                onChange={(e)=>{
                                    editarValorRegistroSolucion('solucionado', e.target.checked? true : false);
                                }}
                            />
                            <div className="slider"></div>
                        </label>
                    </div>
                </div>
            </Modal>
    
        </>
    )
}